import { MenuItemData } from '@components/Navigation/types';
import { mc, StyleProps } from '@styles';
import React, { FC } from 'react';

import MobileDropdownBackBtn from '../BackBtn';
import ChevronRightIcon from './assets/chevronRight.inline.svg';

interface Props extends StyleProps {
  item: MenuItemData;
  onLinkClick?: () => void;
  onGoBack?: () => void;
}

export const MobileTilesViewMenu: FC<Props> = ({ className, item, onLinkClick, onGoBack }) => {
  const { items = [] } = item;
  return (
    <div className={mc('bg-light-gray', className)}>
      <MobileDropdownBackBtn className={mc('w-full')} onClick={onGoBack}>
        {item.title}
      </MobileDropdownBackBtn>
      <div className={mc('w-full', 'px-8 py-2.5', 'font-raleway leading-normal font-semibold text-ocean-blue text-lg')}>
        {item.description}
      </div>
      <div className="px-8 py-6 w-full">
        {items.map(itm => (
          <a
            key={itm.title}
            className={mc(
              'block',
              'h-[96px] w-full',
              'pl-4 pr-6 mt-2.5',
              'rounded-lg',
              'flex flex-row justify-between items-center',
              'text-ocean-blue bg-white stroke-ocean-blue',
              'hover:bg-ocean-blue hover:text-white hover:stroke-white',
            )}
            href={itm.url || '#'}
            onClick={onLinkClick}
          >
            <span className={mc('block', 'mr-6 w-full', 'flex flex-row justify-start items-center')}>
              {!!itm.icon && <span className="mr-6 w-16 h-16 flex justify-center items-center">{itm.icon}</span>}
              <span className={mc('block', 'text-2xl font-raleway leading-normal')}>{itm.title}</span>
            </span>
            <ChevronRightIcon className="block stroke-white" />
          </a>
        ))}
      </div>
    </div>
  );
};

export type MobileTilesViewMenuProps = Props;
export default MobileTilesViewMenu;
